import getImageSrc from "src/utils/getImageSrc.js";

export default function getIconSrcByXmppLogin(xmppLogin) {
  const deviceType = xmppLogin[xmppLogin.length - 1];
  const imageFiles = {
    1: "phone.svg",
    2: "phone.svg",
    3: "tablet.svg",
    4: "notebook.svg",
    5: "phone.svg",
    6: "tablet.svg",
    9: "notebook.svg",
    10: "phone.svg"
  };
  return getImageSrc(imageFiles[deviceType]);
}
